import React from "react";

const MessageA3 = (props) => {
  return (
    <div style={{ display: "flex", width: "100%" }}>
      <div
        className="chat-text"
        style={{ marginBottom: "6px" }}
        dangerouslySetInnerHTML={{ __html: props.item.text }}
      ></div>
    </div>
  );
};

export default MessageA3;
